export default __webpack_public_path__ + "2017 (ASAP) Theory of Nanoscale Organic Cavities The Essential Role of Vibration-Photon Dressed States.pdf";